const options = {
  5: "bg-cyan-300/5",
  10: "bg-cyan-300/10",
  25: "bg-cyan-300/25",
  50: "bg-cyan-300/50",
  75: "bg-cyan-300/75",
  90: "bg-cyan-300/90",
  100: "bg-cyan-300",
};

const from = {
  5: "from-cyan-300/5",
  10: "from-cyan-300/10",
  25: "from-cyan-300/25",
  50: "from-cyan-300/50",
  75: "from-cyan-300/75",
  90: "from-cyan-300/90",
  100: "from-cyan-300",
};

export default function getBackgroundCyan300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
